import React, { useState, useEffect } from 'react';
import API from '../api/api';

const COLS = ['#', 'رقم الفاتورة', 'المبلغ', 'من', 'إلى', 'رسم العداد', 'رسم العامل', ''];

const fmtDate = (d) => {
  if (!d) return '';
  const [y, m, day] = d.split('-');
  return day + '/' + m + '/' + y;
};

export default function Bills({ partnership }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showFeeForm, setShowFeeForm] = useState(false);
  const [editBill, setEditBill] = useState(null);
  const [editFee, setEditFee] = useState(null);
  const [showCollection, setShowCollection] = useState(false);
  const [collectionBill, setCollectionBill] = useState(null);
  const [collectionData, setCollectionData] = useState([]);
  const [collectionSaved, setCollectionSaved] = useState({});
  const [form, setForm] = useState({ bill_number: '', amount: '', from_date: '', to_date: '' });
  const [feeForm, setFeeForm] = useState({ from_date: '', meter_fee: '', worker_fee: '' });
  const [confirm, setConfirm] = useState(null);

  useEffect(() => { load(); }, [partnership.id]);

  const load = async () => {
    setLoading(true);
    const res = await API.get('/elec-bills/' + partnership.id + '/');
    setData(res.data);
    setLoading(false);
  };

  const save = async (e) => {
    e.preventDefault();
    if (editBill) {
      await API.post('/elec-bills/' + partnership.id + '/', { action: 'edit_bill', id: editBill.id, ...form, num: form.bill_number });
    } else {
      await API.post('/elec-bills/' + partnership.id + '/', { ...form, meter_fee: data ? data.meter_fee : 0, worker_fee: data ? data.worker_fee : 0 });
    }
    setShowForm(false); setEditBill(null);
    setForm({ bill_number: '', amount: '', from_date: '', to_date: '' });
    load();
  };

  const saveFee = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (editFee) {
      await API.post('/elec-bills/' + partnership.id + '/', { action: 'edit_fee', id: editFee.id, meter_fee: feeForm.meter_fee, worker_fee: feeForm.worker_fee });
    } else {
      await API.post('/elec-bills/' + partnership.id + '/', { action: 'add_fee_period', from_date: feeForm.from_date, meter_fee: feeForm.meter_fee, worker_fee: feeForm.worker_fee });
    }
    setShowFeeForm(false); setEditFee(null);
    setFeeForm({ from_date: '', meter_fee: '', worker_fee: '' });
    load();
  };

  const doDelete = async () => {
    if (!confirm) return;
    if (confirm.type === 'bill') {
      await API.post('/elec-bills/' + partnership.id + '/', { action: 'delete_bill', id: confirm.id });
    } else {
      await API.post('/elec-bills/' + partnership.id + '/', { action: 'delete_fee', id: confirm.id });
    }
    setConfirm(null); load();
  };

  const startEditBill = (b) => {
    setEditBill(b);
    setForm({ bill_number: b.num, amount: b.amount, from_date: b.from, to_date: b.to });
    setShowForm(true);
  };

  const startEditFee = (f) => {
    setEditFee(f);
    setFeeForm({ from_date: f.from, meter_fee: f.meter_fee, worker_fee: f.worker_fee });
    setShowFeeForm(true);
  };

  const inp = { width: '100%', padding: '7px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box', fontSize: '13px' };
  const lbl = { display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' };
  const btn = (bg) => ({ padding: '7px 16px', background: bg, color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' });

  const bills = data ? data.bills || [] : [];
  const fees = data ? data.fees || [] : [];
  const meterFee = data ? data.meter_fee || 0 : 0;
  const workerFee = data ? data.worker_fee || 0 : 0;
  const totalBills = bills.reduce((s, b) => s + b.amount, 0);

  if (loading) return <div style={{ textAlign: 'center', padding: '30px' }}>جار التحميل...</div>;

  const saveCollection = async (idx) => {
    const p = collectionData[idx];
    if (!p.amount || parseFloat(p.amount) <= 0) { alert('ادخل المبلغ اولا'); return; }
    try {
      await API.post('/detail-revenues/' + partnership.id + '/', {
        partner_id: p.id, amount: parseFloat(p.amount), note: p.note,
        sender: p.transfer_name, date: p.reg_date, transfer_date: p.transfer_date,
      });
      const paid = parseFloat(p.amount) || 0;
      const newBalance = parseFloat(p.balance) + paid;
      const d = [...collectionData];
      d[idx] = { ...d[idx], saved: true, balance: newBalance, original_balance: newBalance, amount: newBalance < -0.01 ? Math.abs(newBalance).toFixed(2) : '0' };
      setCollectionData(d);
    } catch(e) { alert('خطأ: ' + e.message); }
  };

  return (
    <div style={{ padding: '15px' }} dir="rtl">
      {showCollection && collectionBill && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.6)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'white',borderRadius:'12px',width:'96vw',height:'92vh',direction:'rtl',display:'flex',flexDirection:'column',overflow:'hidden'}}>
            <div style={{padding:'16px 20px',background:'#1e3a5f',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <h3 style={{margin:0,color:'white'}}>💰 تحصيل فاتورة رقم ({collectionBill.num})</h3>
              <button onClick={()=>setShowCollection(false)} style={{background:'none',border:'none',color:'white',fontSize:'22px',cursor:'pointer'}}>✕</button>
            </div>
            <div style={{overflowX:'auto',padding:'16px'}}>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
                <thead>
                  <tr style={{background:'#f0f4f8'}}>
                    {['#','اسم الشريك','المديونية','المبلغ','الملاحظة','اسم المحول','تاريخ التسجيل','تاريخ التحويل','إجراء'].map(h=>(
                      <th key={h} style={{padding:'10px 8px',textAlign:'right',borderBottom:'2px solid #ddd'}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {collectionData.map((p, idx) => (
                    <tr key={p.id} style={{background: p.balance > 0.01 ? '#27ae60' : p.balance === 0 ? '#f0fff4' : idx%2===0 ? 'white' : '#fafafa', borderBottom:'1px solid #eee', color: p.balance > 0.01 ? 'white' : 'inherit', fontWeight: p.balance > 0.01 ? 'bold' : 'normal'}}>
                      <td style={{padding:'8px',textAlign:'center'}}>{idx+1}</td>
                      <td style={{padding:'8px',fontWeight:'bold',color:'#1e3a5f',whiteSpace:'nowrap'}}>{p.name}</td>
                      <td style={{padding:'8px',fontWeight:'bold',
                        color: p.balance < -0.01 ? '#e74c3c' : p.balance > 0.01 ? 'white' : '#27ae60',
                        whiteSpace:'nowrap',maxWidth:'130px',overflow:'hidden'}}>
                        {p.balance < -0.01 ? '🔴 مدين ' + Math.abs(p.balance).toFixed(2) + ' ر.س' : p.balance > 0.01 ? '✅ له رصيد ' + p.balance.toFixed(2) : '✅ مسدد'}
                      </td>
                      <td style={{padding:'4px'}}><input type="number" value={p.amount} disabled={p.saved} onChange={e=>{const d=[...collectionData];d[idx]={...d[idx],amount:e.target.value};setCollectionData(d);}} style={{width:'85px',padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px'}}/></td>
                      <td style={{padding:'4px'}}><input type="text" value={p.note} disabled={p.saved} onChange={e=>{const d=[...collectionData];d[idx]={...d[idx],note:e.target.value};setCollectionData(d);}} style={{width:'120px',padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px'}}/></td>
                      <td style={{padding:'4px'}}><input type="text" value={p.transfer_name} disabled={p.saved} onChange={e=>{const d=[...collectionData];d[idx]={...d[idx],transfer_name:e.target.value};setCollectionData(d);}} style={{width:'200px',padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px'}}/></td>
                      <td style={{padding:'4px'}}><input type="date" value={p.reg_date} disabled={p.saved} onChange={e=>{const d=[...collectionData];d[idx]={...d[idx],reg_date:e.target.value};setCollectionData(d);}} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'11px'}}/></td>
                      <td style={{padding:'4px'}}><input type="date" value={p.transfer_date} disabled={p.saved} onChange={e=>{const d=[...collectionData];d[idx]={...d[idx],transfer_date:e.target.value};setCollectionData(d);}} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'11px'}}/></td>
                      <td style={{padding:'4px',whiteSpace:'nowrap'}}>
                        <button onClick={()=>saveCollection(idx)} style={{padding:'5px 8px',background:'#27ae60',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'12px'}}>💾 حفظ</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{padding:'12px 20px',borderTop:'1px solid #eee',textAlign:'left'}}>
              <button onClick={()=>setShowCollection(false)} style={{padding:'8px 24px',background:'#95a5a6',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>إغلاق</button>
            </div>
          </div>
        </div>
      )}
      {confirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: '25px', borderRadius: '10px', textAlign: 'center', minWidth: '280px' }}>
            <div style={{ fontSize: '40px', marginBottom: '10px' }}>⚠️</div>
            <p style={{ fontWeight: 'bold', marginBottom: '20px' }}>هل أنت متأكد من الحذف؟</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button onClick={doDelete} style={btn('#e74c3c')}>نعم، احذف</button>
              <button onClick={() => setConfirm(null)} style={btn('#95a5a6')}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h3 style={{ margin: 0 }}>⚡ فواتير الكهرباء</h3>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => { setShowFeeForm(true); setEditFee(null); setFeeForm({ from_date: '', meter_fee: '', worker_fee: '' }); }} style={btn('#8e44ad')}>+ رسوم جديدة</button>
          <button onClick={() => { setShowForm(true); setEditBill(null); setForm({ bill_number: '', amount: '', from_date: '', to_date: '' }); }} style={btn('#1e3a5f')}>+ فاتورة جديدة</button>
        </div>
      </div>

      <div style={{ background: 'white', padding: '12px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        <div><span style={{ fontSize: '12px', color: '#666' }}>إجمالي الفواتير</span><br /><strong style={{ color: '#e74c3c', fontSize: '18px' }}>{totalBills.toLocaleString('ar-SA', {useGrouping:false})} ر.س</strong></div>
        <div><span style={{ fontSize: '12px', color: '#666' }}>عدد الفواتير</span><br /><strong style={{ fontSize: '18px' }}>{bills.length}</strong></div>
        <div><span style={{ fontSize: '12px', color: '#666' }}>رسم العداد الحالي</span><br /><strong>{meterFee} ر.س</strong></div>
        <div><span style={{ fontSize: '12px', color: '#666' }}>رسم العامل الحالي</span><br /><strong>{workerFee} ر.س</strong></div>
      </div>

      {showForm && (
        <form onSubmit={save} style={{ background: 'white', padding: '15px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 1px 6px rgba(0,0,0,0.1)' }}>
          <h4 style={{ margin: '0 0 12px' }}>{editBill ? 'تعديل فاتورة' : 'فاتورة جديدة'}</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px' }}>
            <div><label style={lbl}>رقم الفاتورة</label><input style={inp} value={form.bill_number} onChange={e => setForm({ ...form, bill_number: e.target.value })} required /></div>
            <div><label style={lbl}>المبلغ</label><input type="number" step="0.01" style={inp} value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} required /></div>
            <div><label style={lbl}>من تاريخ</label><input type="date" style={inp} value={form.from_date} onChange={e => setForm({ ...form, from_date: e.target.value })} required /></div>
            <div><label style={lbl}>إلى تاريخ</label><input type="date" style={inp} value={form.to_date} onChange={e => setForm({ ...form, to_date: e.target.value })} required /></div>
          </div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
            <button type="submit" style={btn('#27ae60')}>حفظ</button>
            <button type="button" onClick={() => { setShowForm(false); setEditBill(null); }} style={btn('#e74c3c')}>إلغاء</button>
          </div>
        </form>
      )}

      {showFeeForm && (
        <div style={{ background: 'white', padding: '15px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 1px 6px rgba(0,0,0,0.1)' }}>
          <h4 style={{ margin: '0 0 12px' }}>{editFee ? 'تعديل رسوم' : 'رسوم جديدة'}</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
            <div><label style={lbl}>من تاريخ</label><input type="date" style={inp} value={feeForm.from_date} onChange={e => setFeeForm({ ...feeForm, from_date: e.target.value })} /></div>
            <div><label style={lbl}>رسم العداد</label><input type="number" step="0.01" style={inp} value={feeForm.meter_fee} onChange={e => setFeeForm({ ...feeForm, meter_fee: e.target.value })} required /></div>
            <div><label style={lbl}>رسم العامل</label><input type="number" step="0.01" style={inp} value={feeForm.worker_fee} onChange={e => setFeeForm({ ...feeForm, worker_fee: e.target.value })} required /></div>
          </div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
            <button onClick={saveFee} style={btn('#27ae60')}>حفظ</button>
            <button onClick={() => { setShowFeeForm(false); setEditFee(null); }} style={btn('#e74c3c')}>إلغاء</button>
          </div>
        </div>
      )}

      {fees.length > 0 && (
        <div style={{ marginBottom: '15px' }}>
          <h4 style={{ margin: '0 0 8px', color: '#8e44ad' }}>سجل رسوم العداد والعامل</h4>
          <div style={{ overflowX: 'auto', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
              <thead style={{position:'sticky',top:0,zIndex:10}}>
                <tr style={{ background: '#8e44ad', color: 'white' }}>
                  {['من تاريخ', 'رسم العداد', 'رسم العامل', ''].map(h => <th key={h} style={{ padding: '9px 8px', fontSize: '12px', textAlign: 'right' }}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {fees.map((f, i) => (
                  <tr key={f.id} style={{ background: i % 2 === 0 ? 'white' : '#f9f4ff', borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '8px', fontSize: '13px' }}>{fmtDate(f.from)}</td>
                    <td style={{ padding: '8px', fontSize: '13px' }}>{f.meter_fee} ر.س</td>
                    <td style={{ padding: '8px', fontSize: '13px' }}>{f.worker_fee} ر.س</td>
                    <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                      <button onClick={() => startEditFee(f)} style={{ padding: '4px 10px', background: '#f39c12', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', marginLeft: '5px' }}>تعديل</button>
                      <button onClick={() => setConfirm({ type: 'fee', id: f.id })} style={{ padding: '4px 10px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>حذف</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div style={{ overflowX: 'auto', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: '8px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
          <thead style={{position:'sticky',top:0,zIndex:10}}>
            <tr style={{ background: '#1e3a5f', color: 'white' }}>
              {COLS.map(h => <th key={h} style={{ padding: '10px 8px', fontSize: '12px', textAlign: 'right' }}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {bills.map((b, i) => (
              <tr key={b.id} style={{ background: i % 2 === 0 ? 'white' : '#f8f9fa', borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold' }}>{i + 1}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold' }}>{b.num}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold', color: '#e74c3c' }}>{b.amount.toLocaleString('ar-SA', {useGrouping:false})} ر.س</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{fmtDate(b.from)}</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{fmtDate(b.to)}</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{b.meter_fee} ر.س</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{b.worker_fee} ر.س</td>
                <td style={{ padding: '9px 8px', whiteSpace: 'nowrap' }}>
                  <button onClick={() => startEditBill(b)} style={{ padding: '4px 10px', background: '#f39c12', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', marginLeft: '5px' }}>تعديل</button>
                  <button onClick={() => setConfirm({ type: 'bill', id: b.id })} style={{ padding: '4px 10px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', marginLeft: '5px' }}>حذف</button>
                  {bills.length > 0 && b.num === Math.max(...bills.map(x=>x.num)) && <button onClick={async () => {
                    setCollectionBill(b);
                    const today = new Date().toISOString().split('T')[0];
                    const res = await API.get(`/bill-collection/${partnership.id}/?bill_id=${b.id}`);
                    const partners = (res.data.partners || []).map(p => {
                      const bal = parseFloat(p.balance) || 0;
                      return {
                        ...p,
                        balance: bal,
                        original_balance: bal,
                        amount: bal < -0.01 ? Math.abs(bal).toFixed(2) : '',
                        note: `فاتورة رقم (${b.num})`,
                        transfer_name: p.name,
                        reg_date: today,
                        transfer_date: today,
                        saved: false,
                      };
                    });
                    setCollectionData(partners);
                    setCollectionSaved({});
                    setShowCollection(true);
                  }} style={{ padding: '4px 10px', background: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>💰 تحصيل</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
